import React from 'react'
import { Container, Text } from './styles'
import { useConfigStore } from '../../store/config'

const Footer: React.FC = () => {
  const { config } = useConfigStore((state) => state)

  // Valores padrão como fallback caso as configurações ainda não estejam preenchidas
  const email = config?.footerEmail || 'contato@aspdoc.com.br'
  const website = config?.footerWebsite || 'www.aspdoc.com.br'
  const address = config?.footerAddress || 'RUA 73 N. º 859 – ALTOS - JEREISSATI – II PACATUBA - CE - CEP 61.814-312'
  const phone = config?.footerPhone || 'FONE - 85 3384.0782'

  return (
    <Container>
      <Text>
        {email} | {website} <br />
        {address} <br />
        {phone}
      </Text>
    </Container>
  )
}

export default Footer
